import { useState, useEffect, useMemo } from 'react'
import {
  DailyRecord,
  EffortMetrics,
  ProductionMetrics,
} from '../types/salesMetrics'
import { subDays, format, addDays, isWeekend } from 'date-fns'

// Real Effort Report Data from 2026-01-13
const EFFORT_REPORT_DATA = [
  {
    team: 'The J-Team',
    loanOfficer: 'Jostyl Ting',
    dmCalls: 4,
    totalDmTalkTime: 126,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 4,
    outbounds: 8,
    totalRcTalkTime: 127,
    totalTalkTime: 253,
    smsSent: 142,
    dmCallsRejected: 4,
    apps: 7,
    cbaSent: 0,
    locks: 3,
    stp: 0,
  },
  {
    team: 'The J-Team',
    loanOfficer: 'Sema Kaderi',
    dmCalls: 4,
    totalDmTalkTime: 44,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 4,
    outbounds: 14,
    totalRcTalkTime: 169,
    totalTalkTime: 213,
    smsSent: 34,
    dmCallsRejected: 2,
    apps: 4,
    cbaSent: 2,
    locks: 3,
    stp: 0,
  },
  {
    team: 'The J-Team',
    loanOfficer: 'Travis Rogalla',
    dmCalls: 6,
    totalDmTalkTime: 70,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 6,
    outbounds: 10,
    totalRcTalkTime: 129,
    totalTalkTime: 199,
    smsSent: 29,
    dmCallsRejected: 1,
    apps: 5,
    cbaSent: 0,
    locks: 0,
    stp: 1,
  },
  {
    team: 'The J-Team',
    loanOfficer: 'Winston Bianco',
    dmCalls: 2,
    totalDmTalkTime: 45,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 2,
    outbounds: 15,
    totalRcTalkTime: 147,
    totalTalkTime: 193,
    smsSent: 49,
    dmCallsRejected: 4,
    apps: 3,
    cbaSent: 1,
    locks: 1,
    stp: 0,
  },
  {
    team: 'The J-Team',
    loanOfficer: 'Andrew Carrillo',
    dmCalls: 7,
    totalDmTalkTime: 122,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 7,
    outbounds: 21,
    totalRcTalkTime: 70,
    totalTalkTime: 192,
    smsSent: 14,
    dmCallsRejected: 0,
    apps: 6,
    cbaSent: 0,
    locks: 1,
    stp: 1,
  },
  {
    team: 'The J-Team',
    loanOfficer: 'Nick Louden',
    dmCalls: 5,
    totalDmTalkTime: 116,
    rehashXfers: 4,
    totalRehashXferTalkTime: 39,
    totalLeadCalls: 9,
    outbounds: 18,
    totalRcTalkTime: 18,
    totalTalkTime: 173,
    smsSent: 30,
    dmCallsRejected: 0,
    apps: 6,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'The J-Team',
    loanOfficer: 'Lee Lopez',
    dmCalls: 5,
    totalDmTalkTime: 74,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 5,
    outbounds: 13,
    totalRcTalkTime: 99,
    totalTalkTime: 173,
    smsSent: 20,
    dmCallsRejected: 1,
    apps: 4,
    cbaSent: 3,
    locks: 0,
    stp: 0,
  },
  {
    team: 'The J-Team',
    loanOfficer: 'Bradley Jones',
    dmCalls: 6,
    totalDmTalkTime: 96,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 6,
    outbounds: 18,
    totalRcTalkTime: 65,
    totalTalkTime: 161,
    smsSent: 23,
    dmCallsRejected: 0,
    apps: 5,
    cbaSent: 2,
    locks: 0,
    stp: 0,
  },
  {
    team: 'The J-Team',
    loanOfficer: 'Michael Li',
    dmCalls: 2,
    totalDmTalkTime: 27,
    rehashXfers: 3,
    totalRehashXferTalkTime: 54,
    totalLeadCalls: 5,
    outbounds: 3,
    totalRcTalkTime: 40,
    totalTalkTime: 121,
    smsSent: 18,
    dmCallsRejected: 1,
    apps: 6,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'The J-Team',
    loanOfficer: 'Larry Honn',
    dmCalls: 4,
    totalDmTalkTime: 76,
    rehashXfers: 1,
    totalRehashXferTalkTime: 5,
    totalLeadCalls: 5,
    outbounds: 8,
    totalRcTalkTime: 17,
    totalTalkTime: 98,
    smsSent: 22,
    dmCallsRejected: 0,
    apps: 4,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'The J-Team',
    loanOfficer: 'Tyler Depreta-Johnson',
    dmCalls: 5,
    totalDmTalkTime: 63,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 5,
    outbounds: 19,
    totalRcTalkTime: 29,
    totalTalkTime: 92,
    smsSent: 15,
    dmCallsRejected: 1,
    apps: 8,
    cbaSent: 2,
    locks: 0,
    stp: 0,
  },
  {
    team: 'The J-Team',
    loanOfficer: 'Bradley Scott Packard',
    dmCalls: 3,
    totalDmTalkTime: 20,
    rehashXfers: 2,
    totalRehashXferTalkTime: 30,
    totalLeadCalls: 5,
    outbounds: 4,
    totalRcTalkTime: 23,
    totalTalkTime: 73,
    smsSent: 13,
    dmCallsRejected: 8,
    apps: 4,
    cbaSent: 0,
    locks: 0,
    stp: 3,
  },
  {
    team: 'The J-Team',
    loanOfficer: 'Adam Zavodny',
    dmCalls: 1,
    totalDmTalkTime: 17,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 1,
    outbounds: 3,
    totalRcTalkTime: 1,
    totalTalkTime: 18,
    smsSent: 3,
    dmCallsRejected: 0,
    apps: 1,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'Mean Breen',
    loanOfficer: 'Joe Andrews',
    dmCalls: 3,
    totalDmTalkTime: 51,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 3,
    outbounds: 20,
    totalRcTalkTime: 204,
    totalTalkTime: 255,
    smsSent: 43,
    dmCallsRejected: 0,
    apps: 3,
    cbaSent: 0,
    locks: 2,
    stp: 2,
  },
  {
    team: 'Mean Breen',
    loanOfficer: 'Larry Gordon Clements',
    dmCalls: 3,
    totalDmTalkTime: 66,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 3,
    outbounds: 9,
    totalRcTalkTime: 146,
    totalTalkTime: 212,
    smsSent: 50,
    dmCallsRejected: 5,
    apps: 3,
    cbaSent: 0,
    locks: 1,
    stp: 1,
  },
  {
    team: 'Mean Breen',
    loanOfficer: 'Sean Ward',
    dmCalls: 2,
    totalDmTalkTime: 121,
    rehashXfers: 1,
    totalRehashXferTalkTime: 17,
    totalLeadCalls: 3,
    outbounds: 7,
    totalRcTalkTime: 68,
    totalTalkTime: 206,
    smsSent: 14,
    dmCallsRejected: 1,
    apps: 5,
    cbaSent: 0,
    locks: 1,
    stp: 0,
  },
  {
    team: 'Mean Breen',
    loanOfficer: 'Broderick Flores',
    dmCalls: 6,
    totalDmTalkTime: 117,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 6,
    outbounds: 11,
    totalRcTalkTime: 82,
    totalTalkTime: 200,
    smsSent: 29,
    dmCallsRejected: 2,
    apps: 6,
    cbaSent: 1,
    locks: 0,
    stp: 0,
  },
  {
    team: 'Mean Breen',
    loanOfficer: 'Laura Hurtado',
    dmCalls: 4,
    totalDmTalkTime: 85,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 4,
    outbounds: 21,
    totalRcTalkTime: 75,
    totalTalkTime: 160,
    smsSent: 22,
    dmCallsRejected: 0,
    apps: 4,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'Mean Breen',
    loanOfficer: 'Graham Woolsey',
    dmCalls: 2,
    totalDmTalkTime: 35,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 2,
    outbounds: 18,
    totalRcTalkTime: 106,
    totalTalkTime: 141,
    smsSent: 22,
    dmCallsRejected: 1,
    apps: 3,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'Mean Breen',
    loanOfficer: 'Gregory Mestas',
    dmCalls: 5,
    totalDmTalkTime: 39,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 5,
    outbounds: 12,
    totalRcTalkTime: 97,
    totalTalkTime: 137,
    smsSent: 60,
    dmCallsRejected: 3,
    apps: 7,
    cbaSent: 2,
    locks: 1,
    stp: 0,
  },
  {
    team: 'Mean Breen',
    loanOfficer: 'Ahmmad Mahmud Aziz',
    dmCalls: 2,
    totalDmTalkTime: 29,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 2,
    outbounds: 10,
    totalRcTalkTime: 91,
    totalTalkTime: 120,
    smsSent: 18,
    dmCallsRejected: 1,
    apps: 3,
    cbaSent: 1,
    locks: 1,
    stp: 1,
  },
  {
    team: 'Mean Breen',
    loanOfficer: 'Jeff G Gray',
    dmCalls: 6,
    totalDmTalkTime: 68,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 6,
    outbounds: 10,
    totalRcTalkTime: 44,
    totalTalkTime: 112,
    smsSent: 19,
    dmCallsRejected: 1,
    apps: 4,
    cbaSent: 1,
    locks: 0,
    stp: 0,
  },
  {
    team: 'Mean Breen',
    loanOfficer: 'Kory Bennion',
    dmCalls: 2,
    totalDmTalkTime: 32,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 2,
    outbounds: 9,
    totalRcTalkTime: 57,
    totalTalkTime: 90,
    smsSent: 22,
    dmCallsRejected: 6,
    apps: 4,
    cbaSent: 0,
    locks: 1,
    stp: 1,
  },
  {
    team: 'Mean Breen',
    loanOfficer: 'Tuan Tran',
    dmCalls: 3,
    totalDmTalkTime: 22,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 3,
    outbounds: 15,
    totalRcTalkTime: 67,
    totalTalkTime: 89,
    smsSent: 115,
    dmCallsRejected: 7,
    apps: 7,
    cbaSent: 4,
    locks: 0,
    stp: 1,
  },
  {
    team: 'Mean Breen',
    loanOfficer: 'Rick Riggin',
    dmCalls: 1,
    totalDmTalkTime: 14,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 1,
    outbounds: 14,
    totalRcTalkTime: 57,
    totalTalkTime: 71,
    smsSent: 31,
    dmCallsRejected: 0,
    apps: 1,
    cbaSent: 0,
    locks: 0,
    stp: 1,
  },
  {
    team: 'Mean Breen',
    loanOfficer: 'Nate Francis',
    dmCalls: 3,
    totalDmTalkTime: 9,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 3,
    outbounds: 4,
    totalRcTalkTime: 47,
    totalTalkTime: 55,
    smsSent: 16,
    dmCallsRejected: 0,
    apps: 0,
    cbaSent: 2,
    locks: 0,
    stp: 1,
  },
  {
    team: 'Mean Breen',
    loanOfficer: 'Ibrahim Zayyid',
    dmCalls: 0,
    totalDmTalkTime: 0,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 0,
    outbounds: 3,
    totalRcTalkTime: 25,
    totalTalkTime: 25,
    smsSent: 4,
    dmCallsRejected: 0,
    apps: 0,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'CouchClosers',
    loanOfficer: 'Scott Marston',
    dmCalls: 2,
    totalDmTalkTime: 73,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 2,
    outbounds: 6,
    totalRcTalkTime: 158,
    totalTalkTime: 231,
    smsSent: 9,
    dmCallsRejected: 1,
    apps: 3,
    cbaSent: 1,
    locks: 1,
    stp: 1,
  },
  {
    team: 'CouchClosers',
    loanOfficer: 'Michael Anthony Bonilla',
    dmCalls: 2,
    totalDmTalkTime: 52,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 2,
    outbounds: 11,
    totalRcTalkTime: 142,
    totalTalkTime: 194,
    smsSent: 8,
    dmCallsRejected: 1,
    apps: 2,
    cbaSent: 1,
    locks: 1,
    stp: 0,
  },
  {
    team: 'CouchClosers',
    loanOfficer: 'Josh Vasquez',
    dmCalls: 5,
    totalDmTalkTime: 170,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 5,
    outbounds: 8,
    totalRcTalkTime: 16,
    totalTalkTime: 186,
    smsSent: 6,
    dmCallsRejected: 8,
    apps: 4,
    cbaSent: 1,
    locks: 0,
    stp: 0,
  },
  {
    team: 'CouchClosers',
    loanOfficer: 'Albano Fejzulla',
    dmCalls: 5,
    totalDmTalkTime: 120,
    rehashXfers: 1,
    totalRehashXferTalkTime: 5,
    totalLeadCalls: 6,
    outbounds: 14,
    totalRcTalkTime: 40,
    totalTalkTime: 165,
    smsSent: 26,
    dmCallsRejected: 0,
    apps: 3,
    cbaSent: 3,
    locks: 1,
    stp: 0,
  },
  {
    team: 'CouchClosers',
    loanOfficer: 'Ryan Mora',
    dmCalls: 3,
    totalDmTalkTime: 96,
    rehashXfers: 1,
    totalRehashXferTalkTime: 19,
    totalLeadCalls: 4,
    outbounds: 13,
    totalRcTalkTime: 41,
    totalTalkTime: 156,
    smsSent: 39,
    dmCallsRejected: 8,
    apps: 5,
    cbaSent: 2,
    locks: 1,
    stp: 0,
  },
  {
    team: 'CouchClosers',
    loanOfficer: 'Brendan Seymour',
    dmCalls: 2,
    totalDmTalkTime: 46,
    rehashXfers: 1,
    totalRehashXferTalkTime: 46,
    totalLeadCalls: 3,
    outbounds: 3,
    totalRcTalkTime: 45,
    totalTalkTime: 136,
    smsSent: 11,
    dmCallsRejected: 1,
    apps: 3,
    cbaSent: 2,
    locks: 1,
    stp: 1,
  },
  {
    team: 'CouchClosers',
    loanOfficer: 'Robert Amato',
    dmCalls: 4,
    totalDmTalkTime: 91,
    rehashXfers: 1,
    totalRehashXferTalkTime: 5,
    totalLeadCalls: 5,
    outbounds: 4,
    totalRcTalkTime: 34,
    totalTalkTime: 130,
    smsSent: 15,
    dmCallsRejected: 2,
    apps: 3,
    cbaSent: 1,
    locks: 1,
    stp: 0,
  },
  {
    team: 'CouchClosers',
    loanOfficer: 'Luis Cuadros',
    dmCalls: 2,
    totalDmTalkTime: 27,
    rehashXfers: 1,
    totalRehashXferTalkTime: 35,
    totalLeadCalls: 3,
    outbounds: 46,
    totalRcTalkTime: 67,
    totalTalkTime: 129,
    smsSent: 6,
    dmCallsRejected: 11,
    apps: 2,
    cbaSent: 1,
    locks: 0,
    stp: 0,
  },
  {
    team: 'CouchClosers',
    loanOfficer: 'Joe Serino',
    dmCalls: 3,
    totalDmTalkTime: 50,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 3,
    outbounds: 19,
    totalRcTalkTime: 78,
    totalTalkTime: 128,
    smsSent: 23,
    dmCallsRejected: 0,
    apps: 4,
    cbaSent: 0,
    locks: 1,
    stp: 0,
  },
  {
    team: 'CouchClosers',
    loanOfficer: 'Caleb Sommer',
    dmCalls: 3,
    totalDmTalkTime: 38,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 3,
    outbounds: 13,
    totalRcTalkTime: 67,
    totalTalkTime: 104,
    smsSent: 166,
    dmCallsRejected: 1,
    apps: 3,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'CouchClosers',
    loanOfficer: 'Justine Fees',
    dmCalls: 1,
    totalDmTalkTime: 12,
    rehashXfers: 2,
    totalRehashXferTalkTime: 16,
    totalLeadCalls: 3,
    outbounds: 5,
    totalRcTalkTime: 65,
    totalTalkTime: 92,
    smsSent: 31,
    dmCallsRejected: 5,
    apps: 1,
    cbaSent: 2,
    locks: 1,
    stp: 1,
  },
  {
    team: 'CouchClosers',
    loanOfficer: 'Dennis Rekedal Jr.',
    dmCalls: 2,
    totalDmTalkTime: 37,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 2,
    outbounds: 9,
    totalRcTalkTime: 52,
    totalTalkTime: 90,
    smsSent: 21,
    dmCallsRejected: 0,
    apps: 2,
    cbaSent: 1,
    locks: 1,
    stp: 0,
  },
  {
    team: 'CouchClosers',
    loanOfficer: 'Adriana Gonzalez',
    dmCalls: 3,
    totalDmTalkTime: 49,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 3,
    outbounds: 7,
    totalRcTalkTime: 19,
    totalTalkTime: 68,
    smsSent: 22,
    dmCallsRejected: 0,
    apps: 1,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'Fillys Best',
    loanOfficer: 'Khuat Vu',
    dmCalls: 2,
    totalDmTalkTime: 22,
    rehashXfers: 3,
    totalRehashXferTalkTime: 58,
    totalLeadCalls: 5,
    outbounds: 65,
    totalRcTalkTime: 169,
    totalTalkTime: 249,
    smsSent: 26,
    dmCallsRejected: 7,
    apps: 4,
    cbaSent: 1,
    locks: 0,
    stp: 1,
  },
  {
    team: 'Fillys Best',
    loanOfficer: 'Shanell Rojas',
    dmCalls: 0,
    totalDmTalkTime: 0,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 0,
    outbounds: 24,
    totalRcTalkTime: 234,
    totalTalkTime: 234,
    smsSent: 37,
    dmCallsRejected: 1,
    apps: 2,
    cbaSent: 2,
    locks: 3,
    stp: 1,
  },
  {
    team: 'Fillys Best',
    loanOfficer: 'Edward Smith',
    dmCalls: 6,
    totalDmTalkTime: 62,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 6,
    outbounds: 20,
    totalRcTalkTime: 136,
    totalTalkTime: 198,
    smsSent: 31,
    dmCallsRejected: 0,
    apps: 3,
    cbaSent: 1,
    locks: 0,
    stp: 2,
  },
  {
    team: 'Fillys Best',
    loanOfficer: 'Joaquin Rivas',
    dmCalls: 3,
    totalDmTalkTime: 60,
    rehashXfers: 1,
    totalRehashXferTalkTime: 38,
    totalLeadCalls: 4,
    outbounds: 13,
    totalRcTalkTime: 73,
    totalTalkTime: 172,
    smsSent: 14,
    dmCallsRejected: 6,
    apps: 1,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'Fillys Best',
    loanOfficer: 'Samantha Graves',
    dmCalls: 4,
    totalDmTalkTime: 53,
    rehashXfers: 1,
    totalRehashXferTalkTime: 17,
    totalLeadCalls: 5,
    outbounds: 33,
    totalRcTalkTime: 91,
    totalTalkTime: 161,
    smsSent: 10,
    dmCallsRejected: 0,
    apps: 7,
    cbaSent: 3,
    locks: 1,
    stp: 0,
  },
  {
    team: 'Fillys Best',
    loanOfficer: 'Henry Steven Behrle',
    dmCalls: 3,
    totalDmTalkTime: 39,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 3,
    outbounds: 10,
    totalRcTalkTime: 111,
    totalTalkTime: 150,
    smsSent: 3,
    dmCallsRejected: 1,
    apps: 3,
    cbaSent: 2,
    locks: 0,
    stp: 1,
  },
  {
    team: 'Fillys Best',
    loanOfficer: 'Breanna Hedayat',
    dmCalls: 3,
    totalDmTalkTime: 35,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 3,
    outbounds: 7,
    totalRcTalkTime: 92,
    totalTalkTime: 127,
    smsSent: 21,
    dmCallsRejected: 0,
    apps: 2,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'Fillys Best',
    loanOfficer: 'Brian Wilson',
    dmCalls: 5,
    totalDmTalkTime: 71,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 5,
    outbounds: 5,
    totalRcTalkTime: 24,
    totalTalkTime: 95,
    smsSent: 28,
    dmCallsRejected: 2,
    apps: 5,
    cbaSent: 4,
    locks: 0,
    stp: 0,
  },
  {
    team: 'Fillys Best',
    loanOfficer: 'Joey Robert Moscatiello',
    dmCalls: 3,
    totalDmTalkTime: 19,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 3,
    outbounds: 1,
    totalRcTalkTime: 73,
    totalTalkTime: 91,
    smsSent: 75,
    dmCallsRejected: 0,
    apps: 1,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'Fillys Best',
    loanOfficer: 'Yvie Huizar',
    dmCalls: 1,
    totalDmTalkTime: 20,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 1,
    outbounds: 11,
    totalRcTalkTime: 66,
    totalTalkTime: 85,
    smsSent: 22,
    dmCallsRejected: 1,
    apps: 1,
    cbaSent: 2,
    locks: 1,
    stp: 0,
  },
  {
    team: 'Fillys Best',
    loanOfficer: 'Tiana Randall',
    dmCalls: 2,
    totalDmTalkTime: 8,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 2,
    outbounds: 5,
    totalRcTalkTime: 75,
    totalTalkTime: 83,
    smsSent: 21,
    dmCallsRejected: 0,
    apps: 2,
    cbaSent: 1,
    locks: 0,
    stp: 1,
  },
  {
    team: 'Fillys Best',
    loanOfficer: 'Richard Kalalani Negrillo',
    dmCalls: 3,
    totalDmTalkTime: 50,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 3,
    outbounds: 9,
    totalRcTalkTime: 31,
    totalTalkTime: 81,
    smsSent: 14,
    dmCallsRejected: 0,
    apps: 3,
    cbaSent: 0,
    locks: 0,
    stp: 1,
  },
  {
    team: 'Fader-Aid',
    loanOfficer: 'Abraham Jimenez',
    dmCalls: 3,
    totalDmTalkTime: 121,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 3,
    outbounds: 6,
    totalRcTalkTime: 131,
    totalTalkTime: 252,
    smsSent: 18,
    dmCallsRejected: 4,
    apps: 2,
    cbaSent: 1,
    locks: 1,
    stp: 1,
  },
  {
    team: 'Fader-Aid',
    loanOfficer: 'Stephen Minor',
    dmCalls: 6,
    totalDmTalkTime: 181,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 6,
    outbounds: 3,
    totalRcTalkTime: 21,
    totalTalkTime: 202,
    smsSent: 13,
    dmCallsRejected: 0,
    apps: 0,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'Fader-Aid',
    loanOfficer: 'Jacob Stanley',
    dmCalls: 4,
    totalDmTalkTime: 72,
    rehashXfers: 2,
    totalRehashXferTalkTime: 26,
    totalLeadCalls: 6,
    outbounds: 10,
    totalRcTalkTime: 43,
    totalTalkTime: 141,
    smsSent: 8,
    dmCallsRejected: 2,
    apps: 4,
    cbaSent: 0,
    locks: 1,
    stp: 1,
  },
  {
    team: 'Fader-Aid',
    loanOfficer: 'Justin Johnson',
    dmCalls: 4,
    totalDmTalkTime: 40,
    rehashXfers: 5,
    totalRehashXferTalkTime: 74,
    totalLeadCalls: 9,
    outbounds: 27,
    totalRcTalkTime: 23,
    totalTalkTime: 136,
    smsSent: 11,
    dmCallsRejected: 5,
    apps: 7,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'Fader-Aid',
    loanOfficer: 'Martin Beltran',
    dmCalls: 5,
    totalDmTalkTime: 45,
    rehashXfers: 2,
    totalRehashXferTalkTime: 26,
    totalLeadCalls: 7,
    outbounds: 29,
    totalRcTalkTime: 60,
    totalTalkTime: 131,
    smsSent: 29,
    dmCallsRejected: 4,
    apps: 9,
    cbaSent: 0,
    locks: 1,
    stp: 1,
  },
  {
    team: 'Fader-Aid',
    loanOfficer: 'Uriel Salinas',
    dmCalls: 3,
    totalDmTalkTime: 50,
    rehashXfers: 1,
    totalRehashXferTalkTime: 30,
    totalLeadCalls: 4,
    outbounds: 3,
    totalRcTalkTime: 51,
    totalTalkTime: 131,
    smsSent: 21,
    dmCallsRejected: 0,
    apps: 2,
    cbaSent: 1,
    locks: 1,
    stp: 0,
  },
  {
    team: 'Fader-Aid',
    loanOfficer: 'Heath Ramsey',
    dmCalls: 6,
    totalDmTalkTime: 53,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 6,
    outbounds: 10,
    totalRcTalkTime: 73,
    totalTalkTime: 126,
    smsSent: 15,
    dmCallsRejected: 8,
    apps: 6,
    cbaSent: 1,
    locks: 0,
    stp: 0,
  },
  {
    team: 'Fader-Aid',
    loanOfficer: 'Angelo Castello',
    dmCalls: 5,
    totalDmTalkTime: 50,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 5,
    outbounds: 6,
    totalRcTalkTime: 42,
    totalTalkTime: 92,
    smsSent: 10,
    dmCallsRejected: 0,
    apps: 3,
    cbaSent: 1,
    locks: 1,
    stp: 0,
  },
  {
    team: 'Fader-Aid',
    loanOfficer: 'Ian Lawrence James',
    dmCalls: 2,
    totalDmTalkTime: 30,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 2,
    outbounds: 8,
    totalRcTalkTime: 57,
    totalTalkTime: 88,
    smsSent: 18,
    dmCallsRejected: 1,
    apps: 1,
    cbaSent: 2,
    locks: 0,
    stp: 0,
  },
  {
    team: 'Fader-Aid',
    loanOfficer: 'Jameson Arus',
    dmCalls: 9,
    totalDmTalkTime: 69,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 9,
    outbounds: 2,
    totalRcTalkTime: 7,
    totalTalkTime: 76,
    smsSent: 2,
    dmCallsRejected: 10,
    apps: 3,
    cbaSent: 0,
    locks: 1,
    stp: 1,
  },
  {
    team: 'Fader-Aid',
    loanOfficer: 'Justin Flores',
    dmCalls: 4,
    totalDmTalkTime: 17,
    rehashXfers: 1,
    totalRehashXferTalkTime: 7,
    totalLeadCalls: 5,
    outbounds: 13,
    totalRcTalkTime: 47,
    totalTalkTime: 71,
    smsSent: 17,
    dmCallsRejected: 19,
    apps: 6,
    cbaSent: 3,
    locks: 1,
    stp: 0,
  },
  {
    team: 'Fader-Aid',
    loanOfficer: 'Christopher Moreno',
    dmCalls: 2,
    totalDmTalkTime: 17,
    rehashXfers: 1,
    totalRehashXferTalkTime: 8,
    totalLeadCalls: 3,
    outbounds: 8,
    totalRcTalkTime: 33,
    totalTalkTime: 59,
    smsSent: 6,
    dmCallsRejected: 4,
    apps: 3,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'Fader-Aid',
    loanOfficer: 'Jay Pasquin',
    dmCalls: 3,
    totalDmTalkTime: 22,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 3,
    outbounds: 2,
    totalRcTalkTime: 7,
    totalTalkTime: 28,
    smsSent: 10,
    dmCallsRejected: 7,
    apps: 2,
    cbaSent: 0,
    locks: 0,
    stp: 1,
  },
  {
    team: 'Fader-Aid',
    loanOfficer: 'Lawrence Mikesell',
    dmCalls: 3,
    totalDmTalkTime: 20,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 3,
    outbounds: 6,
    totalRcTalkTime: 7,
    totalTalkTime: 27,
    smsSent: 27,
    dmCallsRejected: 0,
    apps: 4,
    cbaSent: 0,
    locks: 0,
    stp: 2,
  },
  {
    team: 'The Loan Rangers',
    loanOfficer: 'David Stephenson',
    dmCalls: 2,
    totalDmTalkTime: 52,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 2,
    outbounds: 26,
    totalRcTalkTime: 252,
    totalTalkTime: 304,
    smsSent: 39,
    dmCallsRejected: 2,
    apps: 4,
    cbaSent: 1,
    locks: 1,
    stp: 1,
  },
  {
    team: 'The Loan Rangers',
    loanOfficer: 'Ashley Franco',
    dmCalls: 5,
    totalDmTalkTime: 83,
    rehashXfers: 1,
    totalRehashXferTalkTime: 22,
    totalLeadCalls: 6,
    outbounds: 14,
    totalRcTalkTime: 94,
    totalTalkTime: 198,
    smsSent: 60,
    dmCallsRejected: 0,
    apps: 7,
    cbaSent: 0,
    locks: 1,
    stp: 1,
  },
  {
    team: 'The Loan Rangers',
    loanOfficer: 'Kenneth Lopez',
    dmCalls: 5,
    totalDmTalkTime: 87,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 5,
    outbounds: 9,
    totalRcTalkTime: 38,
    totalTalkTime: 125,
    smsSent: 60,
    dmCallsRejected: 3,
    apps: 6,
    cbaSent: 2,
    locks: 1,
    stp: 1,
  },
  {
    team: 'The Loan Rangers',
    loanOfficer: 'Angel Estrada',
    dmCalls: 6,
    totalDmTalkTime: 55,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 6,
    outbounds: 7,
    totalRcTalkTime: 52,
    totalTalkTime: 107,
    smsSent: 17,
    dmCallsRejected: 0,
    apps: 5,
    cbaSent: 0,
    locks: 1,
    stp: 0,
  },
  {
    team: 'The Loan Rangers',
    loanOfficer: 'Angel Espiritu',
    dmCalls: 1,
    totalDmTalkTime: 2,
    rehashXfers: 1,
    totalRehashXferTalkTime: 5,
    totalLeadCalls: 2,
    outbounds: 14,
    totalRcTalkTime: 100,
    totalTalkTime: 106,
    smsSent: 7,
    dmCallsRejected: 0,
    apps: 0,
    cbaSent: 2,
    locks: 0,
    stp: 1,
  },
  {
    team: 'The Loan Rangers',
    loanOfficer: 'Erick Sadhay Guerrero Rodriguez',
    dmCalls: 7,
    totalDmTalkTime: 48,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 7,
    outbounds: 14,
    totalRcTalkTime: 57,
    totalTalkTime: 105,
    smsSent: 14,
    dmCallsRejected: 1,
    apps: 3,
    cbaSent: 1,
    locks: 0,
    stp: 0,
  },
  {
    team: 'The Loan Rangers',
    loanOfficer: 'Ethan Pope',
    dmCalls: 5,
    totalDmTalkTime: 53,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 5,
    outbounds: 7,
    totalRcTalkTime: 49,
    totalTalkTime: 102,
    smsSent: 27,
    dmCallsRejected: 3,
    apps: 4,
    cbaSent: 0,
    locks: 1,
    stp: 2,
  },
  {
    team: 'The Loan Rangers',
    loanOfficer: 'Daryosh Hariri',
    dmCalls: 1,
    totalDmTalkTime: 19,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 1,
    outbounds: 9,
    totalRcTalkTime: 77,
    totalTalkTime: 97,
    smsSent: 8,
    dmCallsRejected: 5,
    apps: 4,
    cbaSent: 2,
    locks: 0,
    stp: 0,
  },
  {
    team: 'The Loan Rangers',
    loanOfficer: 'Jackson Miles',
    dmCalls: 3,
    totalDmTalkTime: 43,
    rehashXfers: 1,
    totalRehashXferTalkTime: 14,
    totalLeadCalls: 4,
    outbounds: 14,
    totalRcTalkTime: 24,
    totalTalkTime: 82,
    smsSent: 8,
    dmCallsRejected: 10,
    apps: 4,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'The Loan Rangers',
    loanOfficer: 'Kyle Drum',
    dmCalls: 2,
    totalDmTalkTime: 15,
    rehashXfers: 1,
    totalRehashXferTalkTime: 12,
    totalLeadCalls: 3,
    outbounds: 40,
    totalRcTalkTime: 34,
    totalTalkTime: 61,
    smsSent: 12,
    dmCallsRejected: 5,
    apps: 3,
    cbaSent: 0,
    locks: 1,
    stp: 1,
  },
  {
    team: 'The Loan Rangers',
    loanOfficer: 'Chase Cutler',
    dmCalls: 4,
    totalDmTalkTime: 36,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 4,
    outbounds: 0,
    totalRcTalkTime: 16,
    totalTalkTime: 52,
    smsSent: 29,
    dmCallsRejected: 2,
    apps: 2,
    cbaSent: 1,
    locks: 0,
    stp: 0,
  },
  {
    team: 'The Loan Rangers',
    loanOfficer: 'Sierra Mohea Goller',
    dmCalls: 0,
    totalDmTalkTime: 0,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 0,
    outbounds: 0,
    totalRcTalkTime: 1,
    totalTalkTime: 1,
    smsSent: 12,
    dmCallsRejected: 0,
    apps: 0,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'The Loan Rangers',
    loanOfficer: 'Katrina Gyor',
    dmCalls: 0,
    totalDmTalkTime: 0,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 0,
    outbounds: 0,
    totalRcTalkTime: 1,
    totalTalkTime: 1,
    smsSent: 0,
    dmCallsRejected: 0,
    apps: 0,
    cbaSent: 1,
    locks: 0,
    stp: 0,
  },
  {
    team: 'AFL Legacy',
    loanOfficer: 'Michael William Iacouzze',
    dmCalls: 29,
    totalDmTalkTime: 135,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 29,
    outbounds: 45,
    totalRcTalkTime: 176,
    totalTalkTime: 310,
    smsSent: 294,
    dmCallsRejected: 8,
    apps: 20,
    cbaSent: 0,
    locks: 6,
    stp: 4,
  },
  {
    team: 'AFL Legacy',
    loanOfficer: 'Micheal Joseph Moreno',
    dmCalls: 22,
    totalDmTalkTime: 170,
    rehashXfers: 4,
    totalRehashXferTalkTime: 3,
    totalLeadCalls: 30,
    outbounds: 15,
    totalRcTalkTime: 76,
    totalTalkTime: 288,
    smsSent: 37,
    dmCallsRejected: 0,
    apps: 7,
    cbaSent: 0,
    locks: 1,
    stp: 2,
  },
  {
    team: 'AFL Legacy',
    loanOfficer: 'Joseph Dillion Leavitt',
    dmCalls: 6,
    totalDmTalkTime: 64,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 6,
    outbounds: 17,
    totalRcTalkTime: 155,
    totalTalkTime: 219,
    smsSent: 48,
    dmCallsRejected: 4,
    apps: 5,
    cbaSent: 0,
    locks: 2,
    stp: 1,
  },
  {
    team: 'AFL Legacy',
    loanOfficer: 'Mark Anthony Martinez',
    dmCalls: 8,
    totalDmTalkTime: 48,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 8,
    outbounds: 18,
    totalRcTalkTime: 90,
    totalTalkTime: 138,
    smsSent: 48,
    dmCallsRejected: 1,
    apps: 4,
    cbaSent: 0,
    locks: 0,
    stp: 0,
  },
  {
    team: 'AFL Legacy',
    loanOfficer: 'Michael Christopher Kies',
    dmCalls: 1,
    totalDmTalkTime: 12,
    rehashXfers: 0,
    totalRehashXferTalkTime: 0,
    totalLeadCalls: 1,
    outbounds: 6,
    totalRcTalkTime: 65,
    totalTalkTime: 78,
    smsSent: 5,
    dmCallsRejected: 0,
    apps: 0,
    cbaSent: 0,
    locks: 1,
    stp: 0,
  },
]

// Extract unique teams
const TEAMS = Array.from(new Set(EFFORT_REPORT_DATA.map((r) => r.team))).map(
  (teamName) => ({
    id: teamName.toLowerCase().replace(/\s+/g, '-'),
    name: teamName,
  }),
)

// Simple hash function for stable ID generation
function simpleHash(str: string): string {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash
  }
  return Math.abs(hash).toString(36)
}

// Parse time duration string to minutes
function parseDuration(durationStr: string): number {
  if (!durationStr) return 0
  const parts = durationStr.match(/(\d+)\s*days?\s*(\d+):(\d+):(\d+)/)
  if (!parts) return 0
  const days = parseInt(parts[1])
  const hours = parseInt(parts[2])
  const minutes = parseInt(parts[3])
  return days * 24 * 60 + hours * 60 + minutes
}

const generateDailyRecord = (
  date: Date,
  loData: (typeof EFFORT_REPORT_DATA)[0],
): DailyRecord => {
  const isWeekendDay = isWeekend(date)

  // Scale factor: distribute the week's data across 7 days
  // Weekend gets 10% of weekday activity
  const dayFactor = isWeekendDay ? 0.1 : 1.0
  const weekdayCount = 5
  const weekendCount = 2
  const totalWeekFactor = weekdayCount + weekendCount * 0.1
  const dailyScale = dayFactor / totalWeekFactor

  // Add some daily variance (±20%)
  const variance = 0.8 + Math.random() * 0.4
  const scale = dailyScale * variance

  const effort: EffortMetrics = {
    inboundCalls: Math.round((loData.dmCalls || 0) * scale),
    inboundTalkTime: Math.round((loData.totalDmTalkTime || 0) * scale),
    rehashCalls: Math.round((loData.rehashXfers || 0) * scale),
    rehashTalkTime: Math.round((loData.totalRehashXferTalkTime || 0) * scale),
    outboundCalls: Math.round((loData.outbounds || 0) * scale),
    outboundTalkTime: Math.round((loData.totalRcTalkTime || 0) * scale),
    personalLineCalls: Math.round((loData.totalLeadCalls || 0) * scale * 0.1), // Estimate
    personalLineTalkTime: Math.round(
      (loData.totalTalkTime || 0) * scale * 0.05,
    ), // Estimate
    smsSent: Math.round((loData.smsSent || 0) * scale),
    callsRejected: Math.round((loData.dmCallsRejected || 0) * scale),
    missedCalls: Math.round((loData.dmCallsRejected || 0) * scale * 0.3), // Estimate
    declinedTransfers: Math.round((loData.dmCallsRejected || 0) * scale * 0.2), // Estimate
  }

  const production: ProductionMetrics = {
    applications: Math.round((loData.apps || 0) * scale),
    cbasSent: Math.round((loData.cbaSent || 0) * scale),
    locks: Math.round((loData.locks || 0) * scale),
    stps: Math.round((loData.stp || 0) * scale),
  }

  const loId = simpleHash(loData.team + loData.loanOfficer)
  const teamId = loData.team.toLowerCase().replace(/\s+/g, '-')

  return {
    id: `${loId}-${format(date, 'yyyy-MM-dd')}`,
    date: format(date, 'yyyy-MM-dd'),
    loId,
    loName: loData.loanOfficer,
    teamId,
    teamName: loData.team,
    effort,
    production,
  }
}

export function useSalesData() {
  const [data, setData] = useState<DailyRecord[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Generate 45 days of data based on the real effort report
    const records: DailyRecord[] = []
    const today = new Date()
    const startDate = subDays(today, 45)

    for (let i = 0; i <= 45; i++) {
      const currentDate = addDays(startDate, i)

      EFFORT_REPORT_DATA.forEach((loData) => {
        records.push(generateDailyRecord(currentDate, loData))
      })
    }

    setData(records)
    setLoading(false)
  }, [])

  const teams = TEAMS
  const loanOfficers = useMemo(() => {
    const los = new Map()
    data.forEach((record) => {
      if (!los.has(record.loId)) {
        los.set(record.loId, {
          id: record.loId,
          name: record.loName,
          teamId: record.teamId,
        })
      }
    })
    return Array.from(los.values())
  }, [data])

  return {
    data,
    loading,
    teams,
    loanOfficers,
  }
}
